import React from 'react';

const TermsIntro = () => {
  return (
    <div style={{ marginBottom: '50px' }}>
      <div
        className="bg-white"
        style={{
          borderRadius: '25px',
          padding: '45px',
          boxShadow: '0 10px 40px rgba(0, 0, 0, 0.08)',
          borderLeft: '5px solid var(--color-azul-icetex)'
        }}
      >
        <h2
          className="text-texto-oscuro font-extrabold"
          style={{ fontSize: '2rem', marginBottom: '25px' }}
        >
          Introducción
        </h2>
        <p
          className="text-texto-sec"
          style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '20px' }}
        >
          Los términos y condiciones generales que se presentan a continuación establecen la
          regulación, aplicabilidad y el uso que se deben tener en cuenta a la hora de acceder
          al Portal Web de Cursos Virtuales ICETEX (<strong>www.cursosvirtualesicetex.com</strong>).
        </p>
        <p
          className="text-texto-sec"
          style={{ fontSize: '1.05rem', lineHeight: '1.8', marginBottom: '0' }}
        >
          Tan solo con ingresar al Portal Web del ICETEX el cibernauta adopta la condición de
          usuario; por tanto en adelante al referirnos a él se denominará <strong>'usuario'</strong>,
          estado que lo conllevará a aceptar desde el mismo instante que accede al Portal Web,
          plenamente y sin reservas, todos y cada uno de los términos y condiciones que están
          estipulados en la versión publicada por el ICETEX en el documento denominado
          'Términos y condiciones de uso'.
        </p>
      </div>
    </div>
  );
};

export default TermsIntro;
